import { useState, useCallback } from 'react';

export interface GeoCoords {
  lat: number;
  lng: number;
}

export function useCurrentLocation() {
  const [coords, setCoords] = useState<GeoCoords | null>(null);
  const [loading, setLoading] = useState(false);
  const [denied, setDenied] = useState(false);

  const request = useCallback((): Promise<GeoCoords | null> => {
    if (!navigator.geolocation) {
      setDenied(true);
      return Promise.resolve(null);
    }
    setLoading(true);
    return new Promise(resolve => {
      navigator.geolocation.getCurrentPosition(
        pos => {
          const c = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          setCoords(c);
          setLoading(false);
          resolve(c);
        },
        () => {
          setDenied(true);
          setLoading(false);
          resolve(null);
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 },
      );
    });
  }, []);

  return { coords, loading, denied, request };
}
